import moment from 'moment';
import { errorMessages } from '../main';
import { userService } from '../services/UserService';
import { GetParameterByName, isLocalStorageEnabled } from './common';

var tokenName = 'StreamnextHirek';
export let embedDisabled = false;
let _token = '';
const localStorageEnabled = isLocalStorageEnabled();
export function setToken(token) {
  if (global.SNJS && global.SNJS.setToken) {
    global.SNJS.setToken(token);
  }
  if (localStorageEnabled) {
    localStorage.setItem(tokenName, token);
  } else {
    _token = token;
  }
}
export async function setTokenFromQuery(paramName = 'token') {
  try {
    let tokenFromQuery = GetParameterByName(paramName);

    if (tokenFromQuery == '' || tokenFromQuery == null) return false;

    errorMessages.value.push(tokenFromQuery);
    errorMessages.value.push(location.href);
    // console.log(errorMessages);

    if (
      tokenFromQuery &&
      isTokenValid(tokenFromQuery) &&
      (await userService.ValidateToken(tokenFromQuery))
    ) {
      setToken(tokenFromQuery);
      return true;
    }
  } catch (error) {
    console.error('Error in setTokenFromQuery', error);
  }
  return false;
}
export async function setTokenAnonymous(isTokenSet) {
  try {
    let guid = GetParameterByName('UserGuid');
    if (guid) {
      let success = await userService.FromUserGuid(guid);
      if (!success) {
        embedDisabled = true;
      }
      return true;
    }
    let apiKey = GetParameterByName('apiKey');
    if (apiKey) {
      let success = await userService.Embed({ apiKey, isTokenSet });
      if (!success) {
        embedDisabled = true;
      }
      return true;
    }
  } catch (error) {
    console.error('Error in setTokenAnonymous', error);
    return false;
  }
  return true;
}

export function getToken() {
  if (localStorageEnabled) {
    return localStorage.getItem(tokenName);
  } else {
    return _token;
  }
}

export function deleteToken() {
  if (localStorageEnabled) {
    localStorage.removeItem(tokenName);
  } else {
    _token = '';
  }
}

export function isTokenValid(token) {
  token = token ?? getToken();
  if (!token) return false;
  var tokenData = parseJwt(token);
  if (!tokenData) return false;
  return moment().unix() < tokenData.exp;
}

export function parseJwt(token) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error in parseJwt', error);
  }
}
